import * as constants from "./constants";

export const fetchVarianceStatuses = (data) => {
  return {
    type: constants.FETCH_VARIANCE_STATUSES,
    data,
  };
};

export const fetchVarianceStatusesSuccess = (data) => {
  return {
    type: constants.FETCH_VARIANCE_STATUSES_SUCCESS,
    data: data,
  };
};

export const fetchVarianceStatusesError = (data) => {
  return {
    type: constants.FETCH_VARIANCE_STATUSES_ERROR,
    data: data,
  };
};

export const updateVarianceStatuses = (data) => {
  return {
    type: constants.UPDATE_VARIANCE_STATUSES,
    data: data,
  };
};

export const updateVarianceStatusesSuccess = (data) => {
  return {
    type: constants.UPDATE_VARIANCE_STATUSES_SUCCESS,
    data: data,
  };
};

export const updateVarianceStatusesError = () => {
  return {
    type: constants.UPDATE_VARIANCE_STATUSES_ERROR,
  };
};

export const updateVariancesOrder = (data) => {
  return {
    type: constants.UPDATE_ORDER,
    data: data,
  };
};

export const updateVariancesOrderSuccess = (data) => {
  return {
    type: constants.UPDATE_ORDER_SUCCESS,
    data: data,
  };
};

export const updateVariancesOrderError = () => {
  return {
    type: constants.UPDATE_ORDER_ERROR,
  };
};

export const deleteVarianceStatuses = (data) => {
  return {
    type: constants.DELETE_VARIANCE_STATUSES,
    data: data,
  };
};

export const deleteVarianceStatusesSuccess = (data) => {
  return {
    type: constants.DELETE_VARIANCE_STATUSES_SUCCESS,
    data: data,
  };
};

export const deleteVarianceStatusesError = () => {
  return {
    type: constants.DELETE_VARIANCE_STATUSES_ERROR,
  };
};

export const createVarianceStatuses = (data, id) => {
  return {
    type: constants.CREATE_VARIANCE_STATUSES,
    data: data,
  };
};

export const createVarianceStatusesSuccess = (data) => {
  return {
    type: constants.CREATE_VARIANCE_STATUSES_SUCCESS,
    data: data,
  };
};

export const createVarianceStatusesError = (id) => {
  return {
    type: constants.CREATE_VARIANCE_STATUSES_ERROR,
    id,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};

export const setCompletedStatus = (data) => {
  return {
    type: constants.SET_COMPLETED_STATUS,
    data,
  };
};
